export function Separator() {
  return <div className={"h-[4px] w-full bg-brand-secondary"} data-component="Separator" />;
}
